'use client';

import Notification from '@dodao/web-core/components/core/notify/Notification';
import { useNotificationContext } from '@dodao/web-core/ui/contexts/NotificationContext';

export const NotificationWrapper = () => {
  const { notification, hideNotification } = useNotificationContext();

  if (!notification) return null;

  const key = `${notification.heading}_${notification.type}_${notification.duration}_${Date.now()}`;

  return (
    <Notification
      key={key}
      type={notification.type}
      duration={notification.duration}
      heading={notification.heading}
      message={notification.message}
      onClose={hideNotification}
    />
  );
};
